import React from "react";
// import Header from "../../../Components/Header";
// import Sidebar from "../../../Components/Sidebar";
function EscrowMilestone() {
    return (
        <>
            {/* <Header /> */}
            <div className="col-md-9 col-lg-9 col-xxl-10">
                <div className="row ms-lg-4 ms-xl-5 m-0">
                    {/* <div className="col-md-3 col-lg-3 col-xxl-2 p-0">
                      <Sidebar />
                  </div> */}
                    <div className="col-12">
                        <div className="main-heading">
                            <h3> Money Services</h3>
                            <h6>Release Escrow</h6>
                            <p>
                                This function releases the balance of the escrow to the beneficiary.
                            </p>
                        </div>
                        {/* <div className="wallet-information-box m-0">
                            <div className="suspend-text wallet-information-form">
                                <div class="row">
                                    <div class="col-sm-6 col-xl-4 col-xxl-3 mb-4 mb-xl-0">
                                        <div class="mb-5">
                                            <div class="input-box">
                                                <input type="text" placeholder="Public Milestone Address" class="form-control" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex me-0 me-md-4 me-xxl-5">
                                    <button type="button" class="btn cancel-btn mb-3 mb-md-0 me-4">CANCEL</button>
                                    <button type="submit" class="btn next-btn mb-3 mb-md-0">SUSPEND</button>
                                </div>
                            </div>
                        </div>*/}
                    </div>

                </div>
            </div>
            {/* <div className="bg-darks"></div>
            <div className="error-box">
                <div className="error-box-head">
                    <i class="bi bi-exclamation-circle"></i>
                    <h3>Release Escrow</h3>
                </div>
                <div className="p-4">
                    <p>Are you sure you want to release milestone?</p>
                    <div className="wallet-information-box m-0">
                        <div class="d-flex justify-content-end">
                            <button type="button" class="btn cancel-btn mb-3 mb-md-0 me-4">CANCEL</button>
                            <button type="submit" class="btn next-btn mb-3 mb-md-0">RELEASE</button>
                        </div>
                    </div>
                </div>
            </div>*/}

        </>
    );
}

export default EscrowMilestone;
